// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  grantId: __t.u64().primaryKey().name("grant_id"),
  cityId: __t.u64().name("city_id"),
  grantee: __t.identity(),
  grantedBy: __t.identity().name("granted_by"),
  expiresAt: __t.timestamp().name("expires_at"),
});
